module.exports = __webpack_public_path__ + "img/calculator.0ae1cf47.svg";